module.exports = __webpack_public_path__ + "img/材料力学1_6_5.b23d0c0e.jpg";